import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import {hc,html_filter,tc_left} from "./func/util";




Vue.config.productionTip = false
Vue.mixin({
    methods: {
        hc,
        html_filter,
        tc_left,
        getList(list_field,to,from)
        {
            const self = this;
            console.log(to.params)
            console.log(self.$store.state)
            if(parseInt(to.params[list_field]) <= self.$store.state[list_field].page)
            {
                return;
            }
            const check = parseInt(to.params[list_field]) - parseInt(from.params[list_field]);
            if(check > 0)
            {
                self.$store.dispatch('getList',{
                    list_field:list_field,
                    start:parseInt(from.params[list_field])+1,
                    range:parseInt(to.params[list_field])-parseInt(from.params[list_field])
                })
            }
        }
    }
});
const vm = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => {
    // ...

    vm.getList('latest_list',to,from);
    vm.getList('hot_list',to,from);
    next();
})
